var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_14)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M8.92969 3.225L10.5609 6H10.5H7.125C6.08906 6 5.25 5.16094 5.25 4.125C5.25 3.08906 6.08906 2.25 7.125 2.25H7.22812C7.92656 2.25 8.57812 2.62031 8.92969 3.225ZM3 4.125C3 4.8 3.16406 5.4375 3.45 6H1.5C0.670312 6 0 6.67031 0 7.5V10.5C0 11.3297 0.670312 12 1.5 12H22.5C23.3297 12 24 11.3297 24 10.5V7.5C24 6.67031 23.3297 6 22.5 6H20.55C20.8359 5.4375 21 4.8 21 4.125C21 1.84688 19.1531 0 16.875 0H16.7719C15.2766 0 13.8891 0.792188 13.1297 2.08125L12 4.00781L10.8703 2.08594C10.1109 0.792187 8.72344 0 7.22812 0H7.125C4.84688 0 3 1.84688 3 4.125ZM18.75 4.125C18.75 5.16094 17.9109 6 16.875 6H13.5H13.4391L15.0703 3.225C15.4266 2.62031 16.0734 2.25 16.7719 2.25H16.875C17.9109 2.25 18.75 3.08906 18.75 4.125ZM1.5 13.5V21.75C1.5 22.9922 2.50781 24 3.75 24H10.5V13.5H1.5ZM13.5 24H20.25C21.4922 24 22.5 22.9922 22.5 21.75V13.5H13.5V24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftNewImage);
export default __webpack_public_path__ + "static/media/gift-new-image.7a11fe8896d1e06a5ea481908c5d650f.svg";
export { ForwardRef as ReactComponent };